import { __decorate } from "tslib";
import { Component, Input, } from '@angular/core';
let LoadingSpinner = class LoadingSpinner {
    stopThisSpinner = false;
    ngOnChanges(changes) {
        this.stopThisSpinner = Boolean(changes?.stopThisSpinner?.currentValue);
    }
    static propDecorators = {
        stopThisSpinner: [{ type: Input }]
    };
};
LoadingSpinner = __decorate([
    Component({
        selector: 'loadingSpinner',
        template: `
  <div *ngIf=!stopThisSpinner class="loading-spinner">
    <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
  </div>
  `,
    })
], LoadingSpinner);
export { LoadingSpinner };
